// extracted by mini-css-extract-plugin
module.exports = {"Message":"Notifications_Message__2-Ng-","Success":"Notifications_Success__1HKOJ","Error":"Notifications_Error__2ffXi"};